import React from "react";
import { Box, Button, Link } from "@chakra-ui/react";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";

type CtaLinkBtnProps = {
  to: string;
  callout: boolean | null | undefined;
  children: React.ReactNode;
};

const CtaLinkBtn = ({ to, callout, children }: CtaLinkBtnProps) => {
  return (
    <Button size="lg" href={to} as={Link} variant="primary">
      {callout && <Box as="span">⭐&nbsp;</Box>} {children} &nbsp;
      <FiArrowRight />
    </Button>
  );
};

export default CtaLinkBtn;
